import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
export const CFBaseTabbedNavIconTokens = {
    AVATAR_WRAPPER_SIZE: 26,
};
export const CFBaseTabbedNavIconHelpers = {
    avatarFocusRingBorderColor: ({ focused, }) => focused ? CFTokens.COLOR.BACKGROUND_DEFAULT : 'transparent',
    avatarWrapperBorderColor: ({ color, focused, }) => focused ? color : 'transparent',
};
export const CFBaseTabbedNavIconStyles = {
    AvatarFocusRing: css `
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border: 1px solid ${CFBaseTabbedNavIconHelpers.avatarFocusRingBorderColor};
    background-color: transparent;
    border-radius: ${CFTokens.BORDER_RADIUS.PILL};
  `,
    AvatarWrapper: css `
    box-sizing: border-box;
    margin-top: -1px;
    margin-bottom: -1px;
    width: ${CFBaseTabbedNavIconTokens.AVATAR_WRAPPER_SIZE}px;
    height: ${CFBaseTabbedNavIconTokens.AVATAR_WRAPPER_SIZE}px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border-radius: ${CFTokens.BORDER_RADIUS.PILL}px;
    border: 1px solid ${CFBaseTabbedNavIconHelpers.avatarWrapperBorderColor};
  `,
    Root: css `
    position: relative;
  `,
};
